import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { queryKeys } from "@/modules/api/queryKeys";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { notify } from "@/modules/notify/notify";
import { rateSubtaskMutation } from "@/modules/tasks/api/mutations/rateSubtaskMutation";

const translationNamespace = "apiMessages/useRateSubtaskMutation";

export const useRateSubtaskMutation = (onSuccess: () => void) => {
  const jsonApi = useJsonApi();
  const queryClient = useQueryClient();

  const { t } = useTranslation(translationNamespace);

  return useMutation([rateSubtaskMutation.name], {
    mutationFn: rateSubtaskMutation(jsonApi),
    onSuccess: async () => {
      await queryClient.invalidateQueries(
        queryKeys.dashboard.getDashboardTasksList
      );
      onSuccess();
      notify.alert.success(t("The subtask has been rated successfully"));
    },
    onError: (error) => {
      apiErrorValidate(error, {
        403: {
          USER_HAS_NO_PERMISSION: t(
            "You don't have an access to rate the subtask"
          ),
        },
        404: {
          SUBTASK_NOT_FOUND: t(
            "The subtask cannot be found. Please check if you have required permissions"
          ),
        },
        422: {
          SUBTASK_NOT_COMPLETED: t("The subtask has not been completed"),
        },
      });
    },
    retry: false,
  });
};
